import { useEffect, useState } from "react";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MessageCircle, ExternalLink } from "lucide-react";
import { toast } from "sonner";

// Admin button to build a WhatsApp broadcast link from a news title + URL
export default function WABroadcastButton({ title, articleUrl, className = "" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: title || "", url: articleUrl || "" });
  const [waUrl, setWaUrl] = useState("");
  const [msg, setMsg] = useState("");
  const [channelUrl, setChannelUrl] = useState("");

  useEffect(() => {
    api.get("/site-info").then((r) => setChannelUrl(r.data?.whatsapp_channel_url || "")).catch(() => {});
  }, []);

  const build = async () => {
    try {
      const { data } = await api.post("/whatsapp/broadcast-link", form);
      setWaUrl(data.whatsapp_url);
      setMsg(data.message);
    } catch(err) { toast.error(formatError(err)); }
  };

  return (
    <>
      <Button variant="outline" onClick={() => { setForm({ title: title || "", url: articleUrl || "" }); build(); setOpen(true); }} className={`border-emerald-500 text-emerald-700 hover:bg-emerald-50 ${className}`} data-testid="wa-broadcast-btn">
        <MessageCircle className="w-4 h-4 mr-1.5"/>WhatsApp पर भेजें
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>WhatsApp पर ब्रॉडकास्ट करें</DialogTitle>
            <DialogDescription>तैयार संदेश copy करके अपने group/channel में paste करें, या "Open WhatsApp" click करके तुरंत भेजें</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div><Label>शीर्षक</Label><Input value={form.title} onChange={(e) => setForm({...form, title: e.target.value})}/></div>
            <div><Label>लिंक</Label><Input value={form.url} onChange={(e) => setForm({...form, url: e.target.value})}/></div>
            <Button variant="secondary" onClick={build} data-testid="wa-rebuild">संदेश तैयार करें</Button>
            {msg && (
              <div>
                <Label>तैयार संदेश</Label>
                <Textarea rows={6} value={msg} readOnly className="font-mono text-xs" data-testid="wa-message"/>
                <Button variant="outline" className="mt-2" onClick={() => { navigator.clipboard?.writeText(msg); toast.success("Copied"); }}>Copy Message</Button>
              </div>
            )}
          </div>
          <DialogFooter className="gap-2 flex-wrap">
            {channelUrl && <a href={channelUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm text-emerald-700 hover:underline"><ExternalLink className="w-3.5 h-3.5"/>Channel खोलें</a>}
            {waUrl && <a href={waUrl} target="_blank" rel="noopener noreferrer" data-testid="wa-open"><Button className="bg-emerald-500 hover:bg-emerald-600 text-white"><MessageCircle className="w-4 h-4 mr-1.5"/>Open WhatsApp</Button></a>}
            <Button variant="outline" onClick={() => setOpen(false)}>बंद</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
